import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IFormInfoOrderPayload } from "../../types/order";
import { handleRequest } from "../../helpers/handleAsync";
import orderService from "../../services/orderService";

interface IOrderState {
    orderInfo: IFormInfoOrderPayload,
}
const initialState: IOrderState = {
    orderInfo: {
        full_name: "",
        email: "",
        phone: "",
        address: "",
        total_price: 0,
        total_pay: 0,
        discount: 0,
        ref_sub: null,
        ref: null,
        src: null,
        province_id: "",
        district_id: "",
        ward_id: "",
        note: "",
        order_id: "",
        type_link: 1,
        channel: "",
        extra_price: 0,
        products: [],
        combos: [],
        vat_id: null,
        vat_name: null,
    }
}

const createOrder = createAsyncThunk(
    'order/createOrder',
    async (orderInfo: IFormInfoOrderPayload, { dispatch }) => {
        const [res, err] = await handleRequest(orderService.createOrder(orderInfo));
        if (!res || err) {
            throw new Error('Unknow error');
        }
        dispatch(setOrderInfo({ ...orderInfo, order_id: res.order_id }));
        return res;
    }
)

export const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        setOrderInfo(state, action: PayloadAction<IFormInfoOrderPayload>) {
            state.orderInfo = action.payload;
        }
    }
})
export const orderPrvSliceActions = { createOrder };
export const { setOrderInfo } = orderSlice.actions;
export default orderSlice.reducer;